import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from './AuthContext';
import { configuracionAPI } from '../services/api';
import {
  resolveLogoUrl,
  setPrintLogoUrl,
  setPrintEncabezado,
  normalizarEncabezadoImpresion,
  ENCABEZADO_IMPRESION_DEFAULT,
} from '../utils/printBranding';

const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const { user } = useAuth();
  const [logoUrl, setLogoUrl] = useState(null);
  const [encabezadoImpresion, setEncabezadoImpresion] = useState(ENCABEZADO_IMPRESION_DEFAULT);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setLogoUrl(null);
      setEncabezadoImpresion(ENCABEZADO_IMPRESION_DEFAULT);
      setPrintLogoUrl(null);
      setPrintEncabezado(null);
      setLoading(false);
      return;
    }
    try {
      const res = await configuracionAPI.getSistema();
      const url = res.success && res.data?.logo_url ? resolveLogoUrl(res.data.logo_url) : null;
      const enc = normalizarEncabezadoImpresion(res.data?.encabezado_impresion);
      setLogoUrl(url);
      setEncabezadoImpresion(enc);
      setPrintLogoUrl(url);
      setPrintEncabezado(enc);
    } catch {
      setLogoUrl(null);
      setEncabezadoImpresion(ENCABEZADO_IMPRESION_DEFAULT);
      setPrintLogoUrl(null);
      setPrintEncabezado(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const href = logoUrl
      ? `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}v=${Date.now()}`
      : '/api/configuracion/logo';
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = href;
  }, [logoUrl]);

  const value = useMemo(
    () => ({ logoUrl, encabezadoImpresion, loading, refresh }),
    [logoUrl, encabezadoImpresion, loading, refresh]
  );

  return (
    <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>
  );
}

export function useBranding() {
  const ctx = useContext(BrandingContext);
  if (!ctx) {
    return {
      logoUrl: null,
      encabezadoImpresion: ENCABEZADO_IMPRESION_DEFAULT,
      loading: false,
      refresh: async () => {},
    };
  }
  return ctx;
}
